import PropTypes from "prop-types";
import React from "react";

import { getBootstrapData } from "@swa-ui/bootstrap";
import { SelectFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { GENDER_SCHEMA_FIELD_NAME } from "./GenderFormField.schema";

const defaultGenderData = [
  {
    displayValue: i18n("GenderFormField__MALE"),
    label: i18n("GenderFormField__MALE"),
    value: "MALE",
  },
  {
    displayValue: i18n("GenderFormField__FEMALE"),
    label: i18n("GenderFormField__FEMALE"),
    value: "FEMALE",
  },
];

export const GenderFormField = (props) => {
  const { className, disabled, gender, name = GENDER_SCHEMA_FIELD_NAME } = props;
  const genderBootstrapData = getBootstrapData("gender-config");

  return <SelectFormField {...getGenderProps()} />;

  function getGenderProps() {
    return {
      className,
      componentProps: {
        defaultValue: gender,
        list: getGenderData(),
        required: true,
      },
      disabled,
      label: i18n("GenderFormField__GENDER"),
      name,
    };
  }

  function getGenderData() {
    let genderData = defaultGenderData;

    if (genderBootstrapData?.length) {
      genderData = genderBootstrapData.map(({ genderLabel, genderCode, genderId }) => ({
        displayValue: `${genderLabel} (${genderCode})`,
        label: `${genderLabel} (${genderCode})`,
        value: genderId,
      }));
    }

    return [
      {
        displayValue: i18n("GenderFormField__SELECT"),
        label: i18n("GenderFormField__SELECT"),
        value: "",
      },
      ...genderData,
    ];
  }
};

export const genderFormFieldPropTypes = {
  /** Classname for positioning the component. */
  className: PropTypes.string,

  /** Disable the field. */
  disabled: PropTypes.bool,

  /** Selected gender. */
  gender: PropTypes.oneOf(["FEMALE", "MALE", "UNAVAILABLE", "UNDISCLOSED", "UNSPECIFIED"]),

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

GenderFormField.propTypes = genderFormFieldPropTypes;
